export const compareLabelsNullsLast = (a: string | null, b: string | null): number => {
  if (a === b) return 0

  if (a === null) return 1

  if (b === null) return -1

  return a.localeCompare(b)
}
